// Store

import Vue from 'vue';
import Vuex from 'vuex';
// import 'es6-promise/auto';

import state from "./state.js";
import getters from "./getters.js";
import mutations from "./mutations.js";
import actions from "./actions.js";

import app from './modules/app';
import api from './modules/api';
import pub from './modules/pub';
import usr from './modules/usr';

Vue.use(Vuex);

const store = new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
	modules: {
		app,
		api,
		pub,
		usr,
	},
	strict: process.env.NODE_ENV !== 'production',
});

export default store;
